const { uniq } = require('lodash');
const { default: userService } = require('resources/user/user.service');

const assignAgentToClient = async (clientId, agentId) => {
  const user = await userService.getUserById(clientId);

  if (!user) {
    return;
  }

  await userService.updateUser({
    id: clientId,
    realtor_ids: uniq([...user.realtor_ids, agentId]),
  });
};

export default assignAgentToClient;
